export const home = "Accueil";
export const forum = "Forum";
export const groups = "Groupes";
export const messages = "Messages";
export const profile = "Profil";
export const settings = "Paramètres";
export const creators = "Créateurs";
export const dramas = "Séries";
export const search = "Rechercher";
export const login = "Se connecter";
export const signup = "S'inscrire";
export const logout = "Se déconnecter";
export const edit = "Modifier";
export const delete_action = "Supprimer";
export const save = "Enregistrer";
export const cancel = "Annuler";
export const submit = "Soumettre";
export const loading = "Chargement...";
export const error = "Erreur";
export const success = "Succès";
export const warning = "Avertissement";
export const info = "Information";
export const confirm = "Confirmer";
export const yes = "Oui";
export const no = "Non";
export const back = "Retour";
export const next = "Suivant";
export const previous = "Précédent";
export const close = "Fermer";
export const open = "Ouvrir";
export const view = "Voir";
export const hide = "Masquer";
export const show = "Afficher";
export const select = "Sélectionner";
export const clear = "Effacer";
export const reset = "Réinitialiser";
export const refresh = "Actualiser";
export const update = "Mettre à jour";
export const create = "Créer";
export const add = "Ajouter";
export const remove = "Supprimer";
export const share = "Partager";
export const copy = "Copier";
export const paste = "Coller";
export const cut = "Couper";
export const undo = "Annuler";
export const redo = "Rétablir";
export const upload = "Télécharger";
export const download = "Télécharger";
export const print = "Imprimer";
export const email = "E-mail";
export const password = "Mot de passe";
export const username = "Nom d'utilisateur";
export const name = "Nom";
export const title = "Titre";
export const description = "Description";
export const content = "Contenu";
export const category = "Catégorie";
export const tag = "Étiquette";
export const tags = "Étiquettes";
export const date = "Date";
export const time = "Heure";
export const author = "Auteur";
export const post = "Publication";
export const posts = "Publications";
export const comment = "Commentaire";
export const comments = "Commentaires";
export const like = "J'aime";
export const likes = "J'aime";
export const dislike = "Je n'aime pas";
export const vote = "Vote";
export const votes = "Votes";
export const reply = "Répondre";
export const replies = "Réponses";
export const follow = "Suivre";
export const following = "Suivi";
export const followers = "Abonnés";
export const member = "Membre";
export const members = "Membres";
export const online = "En ligne";
export const offline = "Hors ligne";
export const active = "Actif";
export const inactive = "Inactif";
export const public_text = "Public";
export const private_text = "Privé";
export const featured = "En vedette";
export const popular = "Populaire";
export const trending = "Tendance";
export const latest = "Récent";
export const oldest = "Plus ancien";
export const top = "Haut";
export const new_text = "Nouveau";
export const hot = "Chaud";
export const all = "Tout";
export const none = "Aucun";
export const other = "Autre";
export const more = "Plus";
export const less = "Moins";
export const page = "Page";
export const pages = "Pages";
export const item = "Élément";
export const items = "Éléments";
export const result = "Résultat";
export const results = "Résultats";
export const found = "Trouvé";
export const not_found = "Introuvable";
export const empty = "Vide";
export const full = "Plein";
export const available = "Disponible";
export const unavailable = "Indisponible";
export const enabled = "Activé";
export const disabled = "Désactivé";
export const required = "Requis";
export const optional = "Optionnel";
export const invalid = "Invalide";
export const valid = "Valide";